/**
 * Feature flags controlled by environment variables.
 * Set VITE_ENABLE_<FLAG>=true to enable features.
 * 
 * For production, these should be set to 'false' or omitted.
 * For staging/development, set them to 'true'.
 */

export const featureFlags = {
  // Admin page tabs
  showAdminLenders: import.meta.env.VITE_ENABLE_ADMIN_LENDERS === 'true',
  showAdminEntities: import.meta.env.VITE_ENABLE_ADMIN_ENTITIES === 'true',
  showAdminAlerts: import.meta.env.VITE_ENABLE_ADMIN_ALERTS === 'true',

  // Organisation Profile tabs
  showOrgBilling: import.meta.env.VITE_ENABLE_ORG_BILLING === 'true',
  showAdminCloneAsTest: import.meta.env.VITE_ENABLE_ADMIN_CLONE_AS_TEST === 'true',

  // Product Mappings
  showProductMappings: import.meta.env.VITE_ENABLE_PRODUCT_MAPPINGS === 'true',

  // Inventory sub-tabs
  showInventoryTrends: import.meta.env.VITE_ENABLE_INVENTORY_TRENDS === 'true',
  showInventoryFinancingTapes: import.meta.env.VITE_ENABLE_INVENTORY_FINANCING === 'true',
  showInventoryWhatIf: import.meta.env.VITE_ENABLE_INVENTORY_WHATIF === 'true',
  showInventoryAdjust: import.meta.env.VITE_ENABLE_INVENTORY_ADJUST === 'true',

  // Reports tab features
  showReportsNervProjections: import.meta.env.VITE_ENABLE_REPORTS_NERV_PROJECTIONS === 'true',

  // Admin Connections tab
  showAdminConnections: import.meta.env.VITE_ENABLE_ADMIN_CONNECTIONS === 'true',

  // MFA
  showChangePhoneNumber: import.meta.env.VITE_ENABLE_CHANGE_PHONE_NUMBER === 'true',
};

export function isOnStagingUrl(): boolean {
  return typeof window !== 'undefined' && window.location.hostname.startsWith('staging');
}
